var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 23C25.6421 23 29 19.4183 29 15C29 10.5817 25.6421 7 21.5 7C17.3579 7 14 10.5817 14 15C14 19.4183 17.3579 23 21.5 23Z",
    fill: "#CD566C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 20.4547C11.5428 20.4547 6.82918 23.3212 4.56352 27.4958C4.52114 27.6144 4.44918 27.712 4.36816 27.7857C4.19766 27.9409 4.00508 27.977 3.95734 27.9857C3.91816 27.9929 3.88483 27.9962 3.86085 27.9978C3.84831 27.9987 3.83689 27.9992 3.82678 27.9996L3.81226 27.9999L3.80553 28L3.80229 28L3.79991 28C3.79952 28 3.79913 28 3.79911 27.2726L3.79913 28C3.3578 28 3.00003 27.6744 3.00002 27.2726C3.00002 27.2715 3.00003 27.2703 3.00003 27.2692C2.99897 27.1595 3.02511 27.0488 3.08006 26.9456C5.58429 22.2436 10.8698 19 17 19C23.1302 19 28.4157 22.2436 30.92 26.9456C30.9726 27.0445 31 27.153 31 27.2629V27.2724C31 27.6741 30.6422 28 30.2009 28C29.854 28 29.5588 27.7988 29.4483 27.5176C27.1872 23.3312 22.4667 20.4547 17 20.4547ZM3.23407 27.7773C3.22698 27.7708 3.21419 27.7591 3.19816 27.7424C3.20965 27.7543 3.22162 27.7659 3.23407 27.7773Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 7.58562C14.2336 7.58562 11.5856 10.2336 11.5856 13.5C11.5856 16.7664 14.2336 19.4144 17.5 19.4144C20.7664 19.4144 23.4144 16.7664 23.4144 13.5C23.4144 10.2336 20.7664 7.58562 17.5 7.58562ZM10 13.5C10 9.35786 13.3579 6 17.5 6C21.6421 6 25 9.35787 25 13.5C25 17.6421 21.6421 21 17.5 21C13.3579 21 10 17.6421 10 13.5Z",
    fill: "#060606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83138 4.45786C8.93128 1.6834 13.0206 0 17.5 0C27.1658 0 35 7.83421 35 17.5C35 27.1658 27.1658 35 17.5 35C7.83421 35 0 27.1658 0 17.5C0 14.0696 0.987682 10.8687 2.69254 8.1652C2.92533 7.79606 3.41328 7.68553 3.78242 7.91831C4.15156 8.15109 4.2621 8.63905 4.02931 9.00819C2.4786 11.4672 1.58037 14.3772 1.58037 17.5C1.58037 26.293 8.70703 33.4196 17.5 33.4196C26.293 33.4196 33.4196 26.293 33.4196 17.5C33.4196 8.70703 26.293 1.58037 17.5 1.58037C13.4243 1.58037 9.70659 3.1104 6.88535 5.63546C6.56017 5.9265 6.06062 5.89883 5.76957 5.57364C5.47853 5.24846 5.5062 4.74891 5.83138 4.45786Z",
    fill: "#060606"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup6);
export default __webpack_public_path__ + "static/media/Group 6.e0d35e9f9421aed28b4e0a433570a64c.svg";
export { ForwardRef as ReactComponent };